<template>
  <div>
    
    <br>
    <br>
    
    <v-row dense>
      <v-col cols="12" sm="4" md="4">
        <v-select v-model="formulario.estado" :items="['Vigente', 'Anulada', 'Robada', 'Devuelta']" label="Estado"
          outlined clearable />
      </v-col>
      <v-col cols="12" sm="4" md="4">

        <v-text-field v-model="formulario.patente" label="Patente" outlined clearable />
      </v-col>
      <v-col cols="12" sm="4" md="4" v-if="$auth.user().institucion.tipo === 1">
        
        <v-select  v-model="formulario.nombre_institucion" :items="municipalidades"
          label="Municipalidad" outlined clearable />
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field v-model.number="formulario.anio" label="Año Permiso" outlined clearable type="number" />
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-select v-model="formulario.semestre" :items="[1, 2]" label="Semestre Permiso" outlined clearable />
      </v-col>

      <v-col cols="12" sm="4" md="4">
        <v-text-field v-model="formulario.automotora_nombre" label="Automotora" outlined clearable />
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field v-model="formulario.automotora_rut" label="RUT Automotora" outlined clearable />
      </v-col>
      <v-col cols="12" sm="4" md="4" v-if="marcas.length > 0">
        <v-select  v-model="formulario.marca" :items="marcas.map(m => m.marca)" label="Marca"
          outlined clearable />
      </v-col>
      <v-col cols="12" sm="4" md="4" v-if="tipos.length > 0">

        <v-select  v-model="formulario.tipo" :items="tipos.map(m => m.tipo)"
          label="Tipo Vehículo" outlined clearable />
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field v-model="formulario.modelo" label="Modelo" outlined clearable />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="4" md="4">
        <v-btn color="primary" outlined @click="buscar">Actualizar</v-btn>
        </v-col>
        <v-col cols="12" sm="4" md="4"  v-if="patentes && patentes.length > 0">
        <v-btn color="secondary" outlined @click="exportar">Exportar</v-btn>
        </v-col>
        <v-col cols="12" sm="4" md="4">
        <v-btn 
          v-if="$auth.user().institucion.tipo > 1"
          color="primary" 
          outlined 
          :to="'/permisos-provisionales/crear'"
          class="ml-2"
        >
          Agregar Nuevo
        </v-btn>
      </v-col>
      
    </v-row>

    <v-dialog v-model="visible" persistent :max-width="400">
      <v-card>
        <v-card-title class="text-h6">Información</v-card-title>
        <v-card-text>
          <div>
            <p><strong>Estado:</strong> {{ itemSeleccionado.estado }}</p>
            <p><strong>Patente:</strong> {{ itemSeleccionado.patente }}</p>
            <p><strong>Municipalidad:</strong> {{ itemSeleccionado.nombre_institucion }}</p>
            <p><strong>Año Permiso:</strong> {{ itemSeleccionado.anio }}</p>
            <p><strong>Semestre Permiso:</strong> {{ itemSeleccionado.semestre }}</p>
            <p><strong>Marca:</strong> {{ itemSeleccionado.marca }}</p>
            <p><strong>Tipo Vehículo:</strong> {{ itemSeleccionado.tipo_vehiculo }}</p>
            <p><strong>Modelo:</strong> {{ itemSeleccionado.modelo }}</p>
            <p><strong>Año de Fabricación:</strong> {{ itemSeleccionado.anio_fabricacion }}</p>
            <p><strong>Razón Social Automotora:</strong> {{ itemSeleccionado.automotora_razon_social }}</p>
            <p><strong>Nombre Automotora:</strong> {{ itemSeleccionado.automotora_nombre }}</p>
            <p><strong>RUT Automotora:</strong> {{ itemSeleccionado.automotora_rut }}</p>
            <p><strong>Dirección Automotora:</strong> {{ itemSeleccionado.automotora_direccion }}</p>
            <p><strong>Comuna Automotora:</strong> {{ itemSeleccionado.automotora_comuna }}</p>
            <p><strong>RUT Representante Automotora:</strong> {{ itemSeleccionado.automotora_representante_rut }}</p>
            <p><strong>Nombre Representante Automotora:</strong> {{ itemSeleccionado.automotora_representante_nombre }}
            </p>
            <p>{{ itemSeleccionado.log }}</p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="visible = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div v-if="patentes && patentes.length === 0" class="text-center my-5">
      <v-alert type="info" border="left" colored-border>
      No se han encontrado permisos.
      </v-alert>
    </div>

    <v-data-table v-if="patentes && patentes.length > 0" :headers="[
      { text: 'Estado', value: 'estado' },
      { text: 'Municipalidad', value: 'nombre_institucion' },
      { text: 'Patente', value: 'patente' },
      { text: 'Año Permiso', value: 'anio' },
      { text: 'Semestre Permiso', value: 'semestre' },
      { text: 'Automotora', value: 'automotora_nombre' },
      { text: 'RUT Automotora', value: 'automotora_rut' },
      { text: 'Marca', value: 'marca' },
      { text: 'Modelo', value: 'modelo' },
      { text: 'Tipo Vehículo', value: 'tipo_vehiculo' },
      { text: 'Acciones', value: 'acciones' }
    ]" :items="patentes" item-value="id" class="elevation-1">
      <template v-slot:[`item.activo`]="{ item }">
        <v-icon v-if="item.activo" color="green">mdi-check-circle</v-icon>
        <v-icon v-else color="red">mdi-close-circle</v-icon>
      </template>
      <template v-slot:[`item.acciones`]="{ item }">
        <v-menu>
          <template #activator="{ on, attrs }">
            <v-btn v-bind="attrs" color="grey darken-1" icon v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <template>

              <v-list-item :key="detalle" @click="verDetalle(item)">
                <v-list-item-title>Ver detalle</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="item.estado === 'Vigente'" :key="anular" @click="cambiarEstado(item, 'Anulada')">
                <v-list-item-title>Pasar a Anulada</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="item.estado === 'Vigente'" :key="anular" @click="cambiarEstado(item, 'Robada')">
                <v-list-item-title>Pasar a Robada</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="item.estado === 'Vigente'" :key="anular" @click="cambiarEstado(item, 'Devuelta')">
                <v-list-item-title>Pasar a Devuelta</v-list-item-title>
              </v-list-item>
            </template>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>

  </div>
</template>

<script>

import CuentasView from '@/admin/views/Cuentas/CuentasView'
import InputTramite from '@/components/Input/InputTramite'
import ChipCuenta from '@/admin/components/ChipCuenta'
import DialogHistorial from '@/admin/components/DialogHistorial'
import { VTextField } from 'vuetify/lib/components'
import { notificar } from '@/admin/utils/notificar'
import { saveAs } from 'file-saver'

export default {
  components: {
    DialogHistorial,
    ChipCuenta,
    InputTramite,
    CuentasView,
    VTextField
  },
  data() {
    return {
      formulario: {},
      patentes: null,
      marcas: [],
      tipos: [],
      municipalidades:[],
      visible: false,
      itemSeleccionado: {},

    }
  },
  computed: {

  },
  mounted() {
    this.getAuxiliares()
  },
  methods: {
    exportar() {
      this.$axios
        .get(`bum/permisos-provisionales/exportar`, { params: this.formulario, responseType: 'blob' })
        .then((response) => {
          const filename = 'provisionales.xlsx'
          saveAs(response.data, filename)
          // const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          // const url = window.URL.createObjectURL(blob)
          // const a = document.createElement('a')
          // a.href = url
          // a.download = 'patentes_provisorias.xlsx'
          // a.click()
          // window.URL.revokeObjectURL(url)
        }).catch((error) => {
          notificar({
            message: error.response.data.message || 'Error',
            severity: 'error',
          })
        })

    },
    verDetalle(item) {
      this.itemSeleccionado = item
      this.visible = true
    },
    cambiarEstado(patente, estado) {
      this.$axios
        .get(`bum/permisos-provisionales/cambiar-estado/${patente.id}`, { params: { estado } })
        .then((response) => {
          const patenteModificada = response.data.patente
          this.patentes = this.patentes.map((p) => {
            if (p.id === patenteModificada.id) {
              return patenteModificada
            }
            return p
          })
        }).catch((error) => {
          notificar({
            message: error.response.data.message || 'Error',
            severity: 'error',
          })
        })

    },

    activar(patente) {

      this.$axios
        .get(`bum/permisos-provisionales/activar/${patente.id}`)
        .then((response) => {
          const patenteModificada = response.data.patente
          // reemplazar en this.patentes
          this.patentes = this.patentes.map((p) => {
            if (p.id === patenteModificada.id) {
              return patenteModificada
            }
            return p
          })
        })

    },
    desactivar(patente) {
      this.$axios
        .get(`bum/permisos-provisionales/desactivar/${patente.id}`)
        .then((response) => {
          const patenteModificada = response.data.patente
          // reemplazar en this.patentes
          this.patentes = this.patentes.map((p) => {
            if (p.id === patenteModificada.id) {
              return patenteModificada
            }
            return p
          })
        })

    },
    getAuxiliares() {
      this.$axios
        .get(`bum/permisos-provisionales/modelos-vehiculos/marcas`)
        .then((response) => {
          this.marcas = response.data.marcas
        })
      this.$axios
        .get(`bum/permisos-provisionales/modelos-vehiculos/tipos`)
        .then((response) => {
          this.tipos = response.data.tipos
        })
        this.$axios
        .get(`bum/permisos/municipalidades`)
        .then((response) => {
          this.municipalidades = response.data.map(m => m.nombre)
        })
    },
    buscar() {
      this.$axios
        .get(`bum/permisos-provisionales/list`, { params: this.formulario })
        .then((response) => {
          this.patentes = response.data.data
        })
    }

  },
}
</script>
